import { useState } from "react";
import "../css/CalenderSetup.css";

const CalenderSetup = () => {
  const [data, setData] = useState({
    flag: { morning: false, evening: false, all_the_time: false },
    timing: { start_time: null, end_time: null },
  });

  const handleTimingOptionChange = (timingOption) => {
    let updatedTiming = { start_time: null, end_time: null };

    // Depending on the selected timing option, update start and end time
    switch (timingOption) {
      case "Morning (9am to 5pm)":
        updatedTiming.start_time = 9;
        updatedTiming.end_time = 17;
        break;
      case "Evening (6pm to 11pm)":
        updatedTiming.start_time = 18;
        updatedTiming.end_time = 23;
        break;
      case "All Day (12am to 11:59pm)":
        updatedTiming.start_time = 0;
        updatedTiming.end_time = 23;
        break;
    }

    // Update the timing flag
    updatedTiming = {
      ...updatedTiming,
      flag: {
        auto: timingOption === "Auto",
        morning: timingOption === "Morning (9am to 5pm)",
        evening: timingOption === "Evening (6pm to 11pm)",
        custom: timingOption === "Custom",
      },
    };

    setData({ ...data, timing: updatedTiming });
  };
  return (
    <div className="">
      <div className="w-full mt-10 font-bold text-xl text-[#000000CC]">
        Set Timings
      </div>
      <div className="mt-2 flex gap-5 md:gap-10 flex-wrap">
        {["Morning (9am to 5pm)", "Evening (6pm to 11pm)"].map(
          (timingOption) => (
            <div className="flex items-center gap-3 text-sm" key={timingOption}>
              <label className="cu-patient-radio-cont">
                <input
                  type="radio"
                  name="timing"
                  value={timingOption}
                  //   onChange={() => handleTimingOptionChange(timingOption)}
                  //   checked={
                  //     data.timing.flag[timingOption.split(" ")[0].toLowerCase()]
                  //   }
                />
                <span className="cu-checkmark-radio"></span>
                {timingOption}
              </label>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CalenderSetup;
